var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        {
          staticClass:
            "fixed top-30 z-40 w-88 flex-shrink-0 border-r border-slate-400 bg-pure-white"
        },
        [
          _c(
            "div",
            {
              staticClass: "p-6 border-b border-slate-400 flex flex-col gap-3"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "mb-1" },
                    [_c("BlTextBody2", { attrs: { text: "Availabilities" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextTitle3", { attrs: { text: "Therapists" } })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("div", {
                staticClass: "w-full grid place-items-center",
                style: { height: "calc(100vh - 15rem)" }
              })
            : _c(
                "div",
                {
                  staticClass: "overflow-y-auto",
                  style: { height: "calc(100vh - 15rem)" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "py-1 px-3 border-b border-slate-400",
                      attrs: { id: "active-section" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between px-3 py-2 mb-1"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-slate-600",
                            attrs: { text: "Active therapists" }
                          }),
                          _vm._v(" "),
                          _c("BlBubbleCount", {
                            attrs: { count: _vm.activeTherapists.length || 0 }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        _vm._l(_vm.activeTherapists, function(therapist) {
                          return _c(
                            "div",
                            {
                              key: therapist.id,
                              staticClass:
                                "h-11 px-3 flex items-center rounded hover:bg-hover-state cursor-pointer",
                              class: {
                                "bg-slate-300":
                                  _vm.selectedTherapistId === therapist.id
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onSelectTherapist(therapist.id)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "truncate",
                                  attrs: { title: therapist.name }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    attrs: { text: therapist.name }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "py-1 px-3",
                      attrs: { id: "deactive-section" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between px-3 py-2 mb-1 cursor-pointer",
                          on: {
                            click: function($event) {
                              _vm.deactivatedTherapistsOpened = !_vm.deactivatedTherapistsOpened
                            }
                          }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-slate-600",
                            attrs: { text: "Deactive therapists" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("BlBubbleCount", {
                                attrs: {
                                  count: _vm.deactivatedTherapists.length || 0
                                }
                              }),
                              _vm._v(" "),
                              _c("BlIcon", {
                                staticClass:
                                  "w-4 h-4 transition-all duration-300",
                                style: _vm.deactivatedTherapistsOpened
                                  ? { rotate: "0deg" }
                                  : { rotate: "180deg" },
                                attrs: { icon: "chevron-up" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.deactivatedTherapistsOpened
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col gap-1" },
                            _vm._l(_vm.deactivatedTherapists, function(
                              therapist
                            ) {
                              return _c(
                                "div",
                                {
                                  key: therapist.id,
                                  staticClass:
                                    "h-11 px-3 flex items-center rounded hover:bg-hover-state cursor-pointer",
                                  class: {
                                    "bg-slate-300":
                                      _vm.selectedTherapistId === therapist.id
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSelectTherapist(therapist.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "truncate",
                                      attrs: { title: therapist.name }
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        attrs: { text: therapist.name }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pl-88" },
        [
          _c(
            "div",
            {
              staticClass:
                "h-12 px-6 sticky top-30 z-30 bg-slate-300 border-b border-slate-400 flex items-center justify-between gap-4",
              style: { minWidth: "calc(100vw - 22rem - 0.5rem)" }
            },
            [
              _c(
                "div",
                { staticClass: "sticky top-30 left-94" },
                [_c("BlTextBody2", { attrs: { text: _vm.masterDate } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sticky top-30 right-6 flex items-center gap-2"
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlSelectBox", {
                        attrs: { options: _vm.timeslotViewOptions, dense: "" },
                        on: {
                          change: function($event) {
                            return _vm.$emit("set-timeslot-view", $event)
                          }
                        },
                        model: {
                          value: _vm.timeslotView,
                          callback: function($$v) {
                            _vm.timeslotView = $$v
                          },
                          expression: "timeslotView"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", label: "Jump to" },
                    on: {
                      clicked: function($event) {
                        _vm.jumpToOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", label: "Today" },
                    on: {
                      clicked: function($event) {
                        _vm.onDayClick({ date: new Date() })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    staticClass: "rounded-full",
                    attrs: {
                      type: "outlined",
                      dense: "",
                      icon: "chevron-left"
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.onNextClick(-1)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    staticClass: "rounded-full",
                    attrs: {
                      type: "outlined",
                      dense: "",
                      icon: "chevron-right"
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.onNextClick(1)
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("Timeslots", {
            attrs: {
              isCompact: _vm.timeslotView === "compact",
              selectedTherapist: _vm.selectedTherapist,
              selectedRoom: null,
              selectedDate: _vm.date,
              headers: _vm.timeslotHeaders,
              loading: _vm.previewLoading
            },
            on: { "after-commit": _vm.fetchAvailabilities }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.jumpToOpened
        ? _c("JumpToDateModal", {
            attrs: { currentDate: _vm.date, dimension: "weekly" },
            on: {
              "close-modal": function($event) {
                _vm.jumpToOpened = false
              },
              submit: function($event) {
                return _vm.onDayClick({ date: $event })
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bf26f14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf26f14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/Therapist.vue
// module id = null
// module chunks = 